<template>
  <div id="lender-bar">
    <div class="container">
      <div class="lender-bar__wrap">
        <div class="lender-bar__logo">
          <img :src="lenderSelected.img" alt="" class="lender-bar__logo-img">
          <img src="https://cdn.crezu.net/game_flow/src/assets/img/lender__check-i-2.png" alt="" class="lender-bar__logo-check-2">
        </div>
        <div class="lender-bar__text"><p>Has elegido la oferta <i>{{lenderSelected.name}}</i>. Te piden que completes campos adicionales para la aprobación del préstamo.</p></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'LenderBar',
  computed: {
    ...mapState({
      additionalParams: state => state.additionalParams,
      hardcoreAPILenders: state => state.hardcoreAPILenders
    }),
    lenderSelected: function () {
      return this.hardcoreAPILenders[this.additionalParams.lender_id]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/lenderbar";
</style>



// WEBPACK FOOTER //
// src/components/LenderBar.vue